import { Button } from '@/components/ui/button';
import smile from '@/assets/landing/images/smile.svg';
import { SCHEDULE_DEMO_URL } from '@/constants/externalLinks';

export default function CTASection() {
  return (
    <section className="bg-black py-24 relative overflow-hidden">
      <div className="absolute top-8 left-8 hidden md:block z-50 w-[200px] h-[200px]">
        <img src={smile} alt="Smile" className="w-full h-full object-cover animate-slow-rotate" />
      </div>
      <div className="absolute bottom-16 left-1/4 hidden md:block z-50 w-[70px] h-[70px]">
        <img src={smile} alt="Smile" className="w-full h-full object-cover animate-slow-rotate-delay-1" />
      </div>
      <div className="absolute top-1/4 right-12 hidden md:block z-50 w-[95px] h-[95px]" style={{ top: '32px' }}>
        <img src={smile} alt="Smile" className="w-full h-full object-cover animate-slow-rotate-delay-2" />
      </div>
      <div className="absolute right-8 hidden md:block z-50 w-[290px] h-[290px]" style={{ bottom: '-105px' }}>
        <img src={smile} alt="Smile" className="w-full h-full object-cover animate-slow-rotate-delay-3" />
      </div>
      <div className="landing-container relative z-10">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-white font-serif mb-6 max-w-[550px] mx-auto">
            Quer saber o que a sua marca deveria estar fazendo hoje?
          </h2>
          <p className="text-xl text-gray-300 mb-8">Fale com o nosso time.</p>
          <Button asChild className="bg-white text-black hover:bg-gray-100 rounded-lg">
            <a
              href={SCHEDULE_DEMO_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-tracking-id="landing-schedule-demo-cta"
            >
              Agende uma apresentação
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
}

